import Api from 'App/api'

export const getReferrals = Api.post({
  controller: 'referrals',
  action: 'listWithSettings',
})

export const saveReferrals = Api.post({
  controller: 'referrals',
  action: 'save',
})
